import { IValidationType, ValidationType } from '../../../Foundation/models/enums/validation-type.enum';
import { ValidationGroupUIDetailViewModel } from './validation-group-ui-detail.model';
import { ValidationResultModel } from './validation-result.model';
import { ValidationStateModel } from './validation-state.model';

export class ValidationModel {
    public validationResults: ValidationResultModel[];
    public isClean: boolean;
    public isValid: boolean;
    public parsedBody: any;
    public validationTypes: IValidationType[];

    constructor(results: any) {
        this.validationTypes = new ValidationType().GetAll();
        this.validationResults = new Array<ValidationResultModel>();
        if (results) {
            if (results._body) {
                this.parsedBody = JSON.parse(results._body);
            } else if (results.error) {
                this.parsedBody = results.error;
            } else {
                this.parsedBody = results;

                if (results instanceof Array) {
                    for (let i = 0; i < results.length; i++) {
                        const validationResult: ValidationResultModel = <ValidationResultModel> results[i];

                        if (!validationResult.state.validationType) {
                            validationResult.state.validationType = 'Error';
                        }

                        this.validationResults.push(validationResult);
                    }
                }
            }
            if (this.parsedBody.validationResults) {
                for (let i = 0; i < this.parsedBody.validationResults.length; i++) {
                    const validationResult: ValidationResultModel = new ValidationResultModel();
                    validationResult.source = this.parsedBody.validationResults[i].source;
                    validationResult.state.overrideLevel = this.parsedBody.validationResults[i].state.overrideLevel;
                    validationResult.state.overrideMessage = this.parsedBody.validationResults[i].state.overrideMessage;
                    validationResult.state.validationType = this.parsedBody.validationResults[i].state.validationType;
                    validationResult.state.businessTansactionNumberId = this.parsedBody.validationResults[i].state.businessTansactionNumberId;
                    validationResult.state.validationResourceId = this.parsedBody.validationResults[i].state.validationResourceId;
                    validationResult.state.originalValue = this.parsedBody.validationResults[i].state.originalValue;
                    validationResult.state.requestedValue = this.parsedBody.validationResults[i].state.requestedValue;
                    validationResult.state.escalationRequested = this.parsedBody.validationResults[i].state.escalationRequested;
                    validationResult.state.validationGroupTypes = this.parsedBody.validationResults[i].state.validationGroupTypes;
                    validationResult.state.customerNumberId = this.parsedBody.validationResults[i].state.customerNumberId;
                    validationResult.state.vehicleId = this.parsedBody.validationResults[i].state.vehicleId;
                    validationResult.memberNames = this.parsedBody.validationResults[i].memberNames;
                    validationResult.errorMessage = this.parsedBody.validationResults[i].errorMessage;
                    this.validationResults.push(validationResult);
                }

                this.isClean = this.parsedBody.isClean;
                this.isValid = this.parsedBody.isValid;
            }
        }
    }

    public getErrors(validationGroupUIMaps: ValidationGroupUIDetailViewModel[]): ValidationResultModel[] {
        const errors = new Array<ValidationResultModel>();

        this.validationResults.filter(value => value.state.validationType === 'Error')
            .forEach(error => {
                if (validationGroupUIMaps != undefined && error.state.validationGroupTypes != undefined && error.state.validationGroupTypes.length > 0) {
                    const ui = validationGroupUIMaps.find(m => m.validationGroupTypeId == error.state.validationGroupTypes[0]);
                    if (ui != undefined) {
                        error.relatedUIElement = ui.validationGroupUITypeDisplayValue;
                    }
                }
                errors.push(error);
            });

        return errors;
    }

    public setError(error: string, validationType: string) {
        const validationResultModel = new ValidationResultModel();
        validationResultModel.state = new ValidationStateModel();
        validationResultModel.state.validationType = validationType;
        validationResultModel.errorMessage = error;
        this.validationResults.push(validationResultModel);
    }

    public getWarnings(validationGroupUIMaps: ValidationGroupUIDetailViewModel[]): ValidationResultModel[] {
        const warnings = new Array<ValidationResultModel>();

        this.validationResults.filter(value => value.state.validationType === 'Warning')
            .forEach(warning => {
                if (validationGroupUIMaps != undefined && warning.state.validationGroupTypes != undefined && warning.state.validationGroupTypes.length > 0) {
                    const ui = validationGroupUIMaps.find(m => m.validationGroupTypeId == warning.state.validationGroupTypes[0]);
                    if (ui != undefined) {
                        warning.relatedUIElement = ui.validationGroupUITypeDisplayValue;
                    }
                }
                warnings.push(warning);
            });

        return warnings;
    }

    public getOverrides(validationGroupUIMaps: ValidationGroupUIDetailViewModel[]): ValidationResultModel[] {
        const overrides = new Array<ValidationResultModel>();

        this.validationResults.filter(value => value.state.validationType === 'Override')
            .forEach(override => {
                if (validationGroupUIMaps != undefined && override.state.validationGroupTypes != undefined && override.state.validationGroupTypes.length > 0) {
                    const ui = validationGroupUIMaps.find(m => m.validationGroupTypeId == override.state.validationGroupTypes[0]);
                    if (ui != undefined) {
                        override.relatedUIElement = ui.validationGroupUITypeDisplayValue;
                    }
                }
                overrides.push(override);
            });

        return overrides;
    }

    public getApprovals(validationGroupUIMaps: ValidationGroupUIDetailViewModel[]): ValidationResultModel[] {
        const approvals = new Array<ValidationResultModel>();

        this.validationResults.filter(value => (value.state.validationType === 'Approval') || (value.state.validationType === 'MRPApproval') || (value.state.validationType === 'OIGApproval') || (value.state.validationType === 'IgnitionInterlockApproval'))
            .forEach(approval => {
                if (validationGroupUIMaps != undefined && approval.state.validationGroupTypes != undefined && approval.state.validationGroupTypes.length > 0) {
                    const ui = validationGroupUIMaps.find(m => m.validationGroupTypeId == approval.state.validationGroupTypes[0]);
                    if (ui != undefined) {
                        approval.relatedUIElement = ui.validationGroupUITypeDisplayValue;
                    }
                }
                approvals.push(approval);
            });

        return approvals;
    }
    public getInformationalMessages(validationGroupUIMaps: ValidationGroupUIDetailViewModel[]): ValidationResultModel[] {
        const informationalMessages = new Array<ValidationResultModel>();

        this.validationResults.filter(value => value.state.validationType === 'Information')
            .forEach(error => {
                if (validationGroupUIMaps != undefined && error.state.validationGroupTypes != undefined && error.state.validationGroupTypes.length > 0) {
                    const ui = validationGroupUIMaps.find(m => m.validationGroupTypeId == error.state.validationGroupTypes[0]);
                    if (ui != undefined) {
                        error.relatedUIElement = ui.validationGroupUITypeDisplayValue;
                    }
                }
                informationalMessages.push(error);
            });

        return informationalMessages;
    }

    public getConfirmationWarnings(validationGroupUIMaps: ValidationGroupUIDetailViewModel[]): ValidationResultModel[] {
        const confirmationWarnings = new Array<ValidationResultModel>();

        this.validationResults.filter(value => value.state.validationType === 'ConfirmationWarning')
            .forEach(error => {
                const confirmation: any = error;
                confirmation.confirmed = false;
                if (validationGroupUIMaps != undefined && error.state.validationGroupTypes != undefined && error.state.validationGroupTypes.length > 0) {
                    const ui = validationGroupUIMaps.find(m => m.validationGroupTypeId == error.state.validationGroupTypes[0]);
                    if (ui != undefined) {
                        error.relatedUIElement = ui.validationGroupUITypeDisplayValue;
                    }
                }
                confirmationWarnings.push(error);
            });

        return confirmationWarnings;
    }

    public getNMVTISErrors(): ValidationResultModel[] {
        const exceptionMessages = new Array<ValidationResultModel>();

        this.validationResults.filter(value => value.state.validationType === new ValidationType().NMVTISError.value)
            .forEach(error => {
                exceptionMessages.push(error);
            });

        return exceptionMessages;
    }

    public getNMVTISValidationErrors(): ValidationResultModel[] {
        const exceptionMessages = new Array<ValidationResultModel>();

        this.validationResults.filter(value => value.state.validationType === new ValidationType().NMVTISValidationMessage.value)
            .forEach(error => {
                exceptionMessages.push(error);
            });

        return exceptionMessages;
    }

    public getComplianceSatisfyMessages(validationGroupUIMaps: ValidationGroupUIDetailViewModel[]): ValidationResultModel[] {
        const overrides = new Array<ValidationResultModel>();

        this.validationResults.filter(value => value.state.validationType === new ValidationType().SatisfyCompliance.value)
            .forEach(override => {
                if (validationGroupUIMaps != undefined && override.state.validationGroupTypes != undefined && override.state.validationGroupTypes.length > 0) {
                    const ui = validationGroupUIMaps.find(m => m.validationGroupTypeId == override.state.validationGroupTypes[0]);
                    if (ui != undefined) {
                        override.relatedUIElement = ui.validationGroupUITypeDisplayValue;
                    }
                }
                overrides.push(override);
            });

        return overrides;
    }

    public getOverridableComplianceSatisfyMessages(validationGroupUIMaps: ValidationGroupUIDetailViewModel[]): ValidationResultModel[] {
        const overrides = new Array<ValidationResultModel>();

        this.validationResults.filter(value => value.state.validationType === new ValidationType().OverridableSatisfyCompliance.value)
            .forEach(override => {
                if (validationGroupUIMaps != undefined && override.state.validationGroupTypes != undefined && override.state.validationGroupTypes.length > 0) {
                    const ui = validationGroupUIMaps.find(m => m.validationGroupTypeId == override.state.validationGroupTypes[0]);
                    if (ui != undefined) {
                        override.relatedUIElement = ui.validationGroupUITypeDisplayValue;
                    }
                }
                overrides.push(override);
            });

        return overrides;
    }

    public getCDLApprovalMessages(validationGroupUIMaps: ValidationGroupUIDetailViewModel[]): ValidationResultModel[] {
        const overrides = new Array<ValidationResultModel>();

        this.validationResults.filter(value => value.state.validationType === new ValidationType().CDLApproval.value)
            .forEach(override => {
                if (validationGroupUIMaps != undefined && override.state.validationGroupTypes != undefined && override.state.validationGroupTypes.length > 0) {
                    const ui = validationGroupUIMaps.find(m => m.validationGroupTypeId == override.state.validationGroupTypes[0]);
                    if (ui != undefined) {
                        override.relatedUIElement = ui.validationGroupUITypeDisplayValue;
                    }
                }
                overrides.push(override);
            });

        return overrides;
    }

    public getBody() {
        return this.parsedBody;
    }
}
